import React, { useId } from 'react';
import { cn } from '../../lib/classNames';

/**
 * Checkbox accessibile con stile VC (non dipende da Bootstrap form-switch).
 */
export const Checkbox = React.forwardRef(function Checkbox(
  {
    id,
    label,
    checked,
    defaultChecked,
    onChange,
    disabled = false,
    className,
    labelClassName,
    description,
    ...props
  },
  ref
) {
  const autoId = useId();
  const inputId = id || autoId;

  return (
    <label
      htmlFor={inputId}
      className={cn(
        'vc-control',
        disabled && 'vc-control--disabled',
        className
      )}
    >
      <input
        ref={ref}
        id={inputId}
        type="checkbox"
        className="vc-control__input vc-control__input--checkbox"
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
        {...props}
      />
      {(label || description) && (
        <span className={cn('vc-control__text', labelClassName)}>
          {label && <span className="vc-control__label">{label}</span>}
          {description && <span className="vc-control__desc">{description}</span>}
        </span>
      )}
    </label>
  );
});

/**
 * Radio accessibile con stile VC.
 */
export const Radio = React.forwardRef(function Radio(
  {
    id,
    name,
    value,
    label,
    checked,
    defaultChecked,
    onChange,
    disabled = false,
    className,
    labelClassName,
    description,
    ...props
  },
  ref
) {
  const autoId = useId();
  const inputId = id || autoId;

  return (
    <label
      htmlFor={inputId}
      className={cn(
        'vc-control',
        disabled && 'vc-control--disabled',
        className
      )}
    >
      <input
        ref={ref}
        id={inputId}
        type="radio"
        name={name}
        value={value}
        className="vc-control__input vc-control__input--radio"
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
        {...props}
      />
      {(label || description) && (
        <span className={cn('vc-control__text', labelClassName)}>
          {label && <span className="vc-control__label">{label}</span>}
          {description && <span className="vc-control__desc">{description}</span>}
        </span>
      )}
    </label>
  );
});

/**
 * Scelta binaria esplicita (Attivo/Disattivo) — più chiara degli switch.
 */
export function BooleanChoice({
  value,
  onChange,
  trueLabel = 'Sì',
  falseLabel = 'No',
  disabled = false,
  className,
  size = 'sm',
  name
}) {
  const btnSize = size === 'sm' ? 'btn-sm' : '';
  return (
    <div className={cn('btn-group vc-boolean-choice', className)} role="group" aria-label={name || 'Scelta'}>
      <button
        type="button"
        className={cn('btn', btnSize, value ? 'btn-success' : 'btn-outline-secondary')}
        disabled={disabled}
        aria-pressed={value === true}
        onClick={() => onChange?.(true)}
      >
        {trueLabel}
      </button>
      <button
        type="button"
        className={cn('btn', btnSize, !value ? 'btn-secondary' : 'btn-outline-secondary')}
        disabled={disabled}
        aria-pressed={value === false}
        onClick={() => onChange?.(false)}
      >
        {falseLabel}
      </button>
    </div>
  );
}
